<template>
  <div>

    <h4 class="title is-4 has-text-primary-dark">
      {{capper.title}}
    </h4>

    <div v-if="!capper.picks.length">
      <h5 class="title is-5">Picks will be posted soon. Check back later.</h5>
    </div>

    <div v-for="(pick, i) in capper.picks"
         :key="`pick-${pick.id}`"
         :class="pickWrapperClasses(i === capper.picks.length - 1)">

      <pick v-if="pick.type !== 'Parlay'"
            :pick="pick"
            :column-classes="pickColumnClasses()" />

      <parlay-pick v-else
                   :parlay="pick"
                   :column-classes="pickColumnClasses()" />

    </div>

  </div>
</template>

<script>
import {pickWrapperClasses, pickColumnClasses} from '@/utils/misc';
import Pick from '@/components/members/Pick';
import ParlayPick from '@/components/members/ParlayPick';

export default {
  components: {
    Pick,
    ParlayPick
  },
  props: {
    capper: Object
  },
  methods: {
    pickWrapperClasses: pickWrapperClasses,
    pickColumnClasses: pickColumnClasses
  }
}
</script>
